/* tslint:disable */
 
import { DataEntityField } from './data-entity-field';
export class InternalEntity {
  deletedFields?: Array<{
}>;
  displayOption?: 0 | 1 | 2 | 3;
  fields: Array<DataEntityField>;
  id?: string;
  validation: string;
}
